import { render, staticRenderFns } from "./domesticTable.vue?vue&type=template&id=a05605a8&scoped=true&"
import script from "./domesticTable.vue?vue&type=script&lang=js&"
export * from "./domesticTable.vue?vue&type=script&lang=js&"
import style0 from "./domesticTable.vue?vue&type=style&index=0&id=a05605a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05605a8",
  null
  
)

export default component.exports